var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useDebounceFn } from "../../utils/hooks/useDebounce";
import { Button } from "../Button";
const defaultProps = {
    "data-testid": "carousel-button",
};
const CarouselButton = (_a) => {
    var { iconName, className, disabled, onClick } = _a, rest = __rest(_a, ["iconName", "className", "disabled", "onClick"]);
    const classList = classNames("carousel-button", className);
    return (_jsx(Button
    /* the onclick has been debounced to prevent wrong animation if user click compulsively */
    , Object.assign({ 
        /* the onclick has been debounced to prevent wrong animation if user click compulsively */
        onClick: useDebounceFn(onClick, 250), rounded: true, className: classList, iconName: iconName, disabled: disabled }, rest)));
};
CarouselButton.defaultProps = defaultProps;
export default CarouselButton;
